import React, { useEffect, useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import Select from 'react-select';
import { isPractice } from 'utils/userTypeHelper';
import useUser from 'utils/useUser';
import forms from 'constants/forms';
import common from 'constants/common';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from 'components/molecules/pagination';
import AutoCompleteDoctors from 'components/molecules/autocompleteFilter/doctor';
import AutoCompleteClinics from 'components/molecules/autocompleteFilter/adminPanelClinic';
import { formatRoleName } from 'utils/formatters';

const Toolbar = () => {
  const { userType } = useUser();
  const DEFAULT_PATIENT_FILTER = forms.patientFilterOptions[0];
  const DEFAULT_CLINIC_FILTER = forms.clinicFilterOptions[0];
  const statusFilterOptions = forms.loginStatusFilterSelect;

  const selectTheme = (theme) => ({
    ...theme,
    borderRadius: 12,
    colors: {
      ...theme.colors,
      ...common.primaryColors,
    },
  });
  const {
    page,
    data,
    itemsPerPage,
    totalCount,
    roles,
    filters: { role, clinicGuid, status },
  } = useSelector((state) => state.adminPanelUsers);

  const rolesOptions = useMemo(() => [
    {
      value: null,
      payload: 'all',
      label: 'All',
    },
    ...roles.map(({ guid, name }) => ({
      value: guid,
      payload: name,
      label: formatRoleName(name),
    })),
  ]);

  const roleValue = useMemo(
    () =>
      rolesOptions.find(({ payload }) => role === payload) || rolesOptions[0],
  );
  const statusValue = useMemo(() =>
    statusFilterOptions.find(({ value }) => status === value),
  );

  const {
    adminPanelUsers: { setFilters, setUsersPage, reset },
  } = useDispatch();
  const setPage = (pageOffset) => {
    setUsersPage({ pageOffset });
  };

  const clinicsFilter = DEFAULT_CLINIC_FILTER;
  const patientFilter = DEFAULT_PATIENT_FILTER;
  useEffect(() => {
    reset();
  }, []);

  return (
    <Row>
      <Col sm={3} md={2}>
        <strong>Full Name</strong>
        <AutoCompleteDoctors
          roleName={role}
          status={status}
          clinicGuid={clinicGuid}
          filter={patientFilter}
          getInactiveClinicData
          handleClick={({ value }) => {
            setFilters({ guid: value });
          }}
        />
      </Col>
      <Col sm={3} md={2}>
        <strong>Role</strong>
        <Select
          options={rolesOptions}
          defaultValue={role}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          value={roleValue}
          onChange={({ payload }) => setFilters({ role: payload })}
        />
      </Col>
      {!isPractice(userType) && (
        <Col sm={3} md={2}>
          <strong>Clinic</strong>
          <AutoCompleteClinics
            filter={clinicsFilter}
            handleClick={({ value }) => {
              setFilters({ clinicGuid: value });
            }}
          />
        </Col>
      )}
      <Col sm={3} md={2}>
        <strong>Status</strong>
        <Select
          options={statusFilterOptions}
          defaultValue={statusFilterOptions[0]}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          value={statusValue}
          onChange={({ value }) => {
            setFilters({ status: value });
          }}
        />
      </Col>

      <Col column="4" />
      <Col sm={3} md={2}>
        <Pagination
          title=""
          page={page}
          pageTotal={data.length}
          itemsPerPage={itemsPerPage}
          total={totalCount}
          handleFirstClick={() => setPage(-(page - 1))}
          handleLastClick={() => setPage(Math.ceil(totalCount / itemsPerPage))}
          handlePrevClick={() => setPage(-1)}
          handleNextClick={() => setPage(+1)}
          loading={false}
        />
      </Col>
    </Row>
  );
};

export default Toolbar;
